<app-customer-review-layout
  [headerCtaLabel]="'SIGNUP.ALREADY_HAVE_ACCOUNT' | translate"
  [headerCtaRoute]="loginRoute"
  [title]="'ACTION.SIGN_UP' | translate"
  [subtitle]="'SIGNUP.SEND_PROFESSIONAL_INVOICES' | translate"
  [errorMessage]="error$ | async"
  [trackingObject]="trackingObject$ | async"
  [trackingScreenName]="trackingScreenName"
  (facebookLoginSuccess)="createAccountByFacebook($event.email, $event.idToken)"
  (facebookLoginError)="setErrorMessage($event.message)"
  (appleLoginSuccess)="createAccountByApple($event.email, $event.idToken)"
  (appleLoginError)="setErrorMessage($event.message)"
  (googleLoginSuccess)="createAccountByGoogle($event.email, $event.idToken)"
  (googleLoginError)="setErrorMessage($event.message)"
>
  <app-email-signup
    class="email-signup"
    [trackingObject]="trackingObject$ | async"
    [trackingAction]="emailSignUpTrackingAction"
    [processing]="processing$ | async"
    [legalNote]="legalNote$ | async"
    [showLegalNote]="true"
    (buttonSubmit)="
      createAccountByEmailAndPassword($event.email, $event.password)
    "
  >
  </app-email-signup>
</app-customer-review-layout>
